// @ngInject
function ResourcesService($translate, $q,DS, DSHttpAdapter, $rootScope) {
    var savedTimestamps = [];
    var apiFactory = {
        get: apiFactoryGet,
        create: apiFactoryCreate,
        update: apiFactoryUpdate,
        save: apiFactorySave,
        delete: apiFactoryDelete
    };

    var apiRms2Factory = {
        get: apiRms2FactoryGet,
        create: apiRms2FactoryCreate,
        update: apiRms2FactoryUpdate,
        save: apiRms2FactorySave,
        delete: apiRms2FactoryDelete
    };

    return {
        handleResourceError: handleResourceError,
        updateSavedTimestamp: updateSavedTimestamp,
        getSavedTimestamp: getSavedTimestamp,
        apiFactory: apiFactory,
        apiRms2Factory: apiRms2Factory
    };


    function apiFactoryGet(relativeUrl, typeName, errorHandler) {

        if (!errorHandler) {
            errorHandler = handleResourceError;
        }

        return function(args) {

            var deferred = $q.defer();
            var req = null;
            if (!req && !isNaN(args)) {
                req = DSHttpAdapter.GET(DS.defaults.basePath + relativeUrl + '/' + args);
            }
            if (!req) {
                if (args && !args.params) {
                    args = { params: args};
                }
                req = DSHttpAdapter.GET(DS.defaults.basePath + relativeUrl, args);
            }

            req.then(function(response) {
                deferred.resolve(response.data);
            }, function(error) {
                deferred.reject(errorHandler(error));
            });

            return deferred.promise;

        };
    }

    function apiFactoryDelete(relativeUrl, typeName, errorHandler) {

        if (!errorHandler) {
            errorHandler = handleResourceError;
        }

        return function(args) {

            var deferred = $q.defer();
            var req = null;
            if (!req && !isNaN(args)) {
                req = DSHttpAdapter.DEL(DS.defaults.basePath + relativeUrl + '/' + args);
            }
            if (!req) {
                req = DSHttpAdapter.DEL(DS.defaults.basePath + relativeUrl, args);
            }

            req.then(function(response) {
                deferred.resolve(response.data);
                $rootScope.$emit(typeName + '.Deleted', response.data);
                $rootScope.$emit(typeName + '.Changed', response.data);
            }, function(error) {
                deferred.reject(errorHandler(error));
            });

            return deferred.promise;

        };
    }

    function apiFactoryUpdate(relativeUrl, typeName, errorHandler) {

        if (!errorHandler) {
            errorHandler = handleResourceError;
        }

        if (!typeName) {
            typeName = 'Object';
        }

        return function(args) {

            var deferred = $q.defer();
            var req = DSHttpAdapter.PUT(DS.defaults.basePath + relativeUrl, args);

            req.then(function(response) {
                deferred.resolve(response.data);
                $rootScope.$emit(typeName + '.Updated', response.data);
                $rootScope.$emit(typeName + '.Changed', response.data);
            }, function(error) {
                deferred.reject(errorHandler(error));
            });

            return deferred.promise;

        };
    }

    function apiFactorySave(relativeUrl, typeName, errorHandler) {

        if (!errorHandler) {
            errorHandler = handleResourceError;
        }

        if (!typeName) {
            typeName = 'Object';
        }

        return function(args) {

            var deferred = $q.defer();
            var req = DSHttpAdapter.POST(DS.defaults.basePath + relativeUrl, args);

            req.then(function(response) {
                deferred.resolve(response.data);
                $rootScope.$emit(typeName + '.Saved', response.data);
                $rootScope.$emit(typeName + '.Changed', response.data);
            }, function(error) {
                deferred.reject(errorHandler(error));
            });

            return deferred.promise;

        };
    }

    function apiFactoryCreate(relativeUrl, typeName, errorHandler) {

        if (!errorHandler) {
            errorHandler = handleResourceError;
        }

        if (!typeName) {
            typeName = 'Object';
        }

        return function(args) {

            var deferred = $q.defer();
            var req = DSHttpAdapter.POST(DS.defaults.basePath + relativeUrl, args);

            req.then(function(response) {
                deferred.resolve(response.data);
                $rootScope.$emit(typeName + '.Created', response.data);
                $rootScope.$emit(typeName + '.Changed', response.data);
            }, function(error) {
                deferred.reject(errorHandler(error));
            });

            return deferred.promise;

        };
    }

    
    function apiRms2FactoryGet(relativeUrl, typeName, errorHandler) {

        if (!errorHandler) {
            errorHandler = handleResourceError;
        }

        return function(args) {

            var deferred = $q.defer();
            var req = null;
            if (!req && !isNaN(args)) {
                req = DSHttpAdapter.GET(DS.defaults.rms2Path + relativeUrl + '/' + args);
            }
            if (!req) {
                if (args && !args.params) {
                    args = { params: args};
                }
                req = DSHttpAdapter.GET(DS.defaults.rms2Path + relativeUrl, args);
            }

            req.then(function(response) {
                deferred.resolve(response.data);
            }, function(error) {
                deferred.reject(errorHandler(error));
            });

            return deferred.promise;

        };
    }

    function apiRms2FactoryDelete(relativeUrl, typeName, errorHandler) {

        if (!errorHandler) {
            errorHandler = handleResourceError;
        }

        return function(args) {

            var deferred = $q.defer();
            var req = null;
            if (!req && !isNaN(args)) {
                req = DSHttpAdapter.DEL(DS.defaults.rms2Path + relativeUrl + '/' + args);
            }
            if (!req) {
                req = DSHttpAdapter.DEL(DS.defaults.rms2Path + relativeUrl, args);
            }

            req.then(function(response) {
                deferred.resolve(response.data);
                $rootScope.$emit(typeName + '.Deleted', response.data);
                $rootScope.$emit(typeName + '.Changed', response.data);
            }, function(error) {
                deferred.reject(errorHandler(error));
            });

            return deferred.promise;

        };
    }

    function apiRms2FactoryUpdate(relativeUrl, typeName, errorHandler) {

        if (!errorHandler) {
            errorHandler = handleResourceError;
        }

        if (!typeName) {
            typeName = 'Object';
        }

        return function(args) {

            var deferred = $q.defer();
            var req = DSHttpAdapter.PUT(DS.defaults.rms2Path + relativeUrl, args);

            req.then(function(response) {
                deferred.resolve(response.data);
                $rootScope.$emit(typeName + '.Updated', response.data);
                $rootScope.$emit(typeName + '.Changed', response.data);
            }, function(error) {
                deferred.reject(errorHandler(error));
            });

            return deferred.promise;

        };
    }

    function apiRms2FactorySave(relativeUrl, typeName, errorHandler) {

        if (!errorHandler) {
            errorHandler = handleResourceError;
        }

        if (!typeName) {
            typeName = 'Object';
        }

        return function(args) {

            var deferred = $q.defer();
            var req = DSHttpAdapter.POST(DS.defaults.rms2Path + relativeUrl, args);

            req.then(function(response) {
                deferred.resolve(response.data);
                $rootScope.$emit(typeName + '.Saved', response.data);
                $rootScope.$emit(typeName + '.Changed', response.data);
            }, function(error) {
                deferred.reject(errorHandler(error));
            });

            return deferred.promise;

        };
    }

    function apiRms2FactoryCreate(relativeUrl, typeName, errorHandler) {

        if (!errorHandler) {
            errorHandler = handleResourceError;
        }

        if (!typeName) {
            typeName = 'Object';
        }

        return function(args) {

            var deferred = $q.defer();
            var req = DSHttpAdapter.POST(DS.defaults.rms2Path + relativeUrl, args);

            req.then(function(response) {
                deferred.resolve(response.data);
                $rootScope.$emit(typeName + '.Created', response.data);
                $rootScope.$emit(typeName + '.Changed', response.data);
            }, function(error) {
                deferred.reject(errorHandler(error));
            });

            return deferred.promise;

        };
    }

    function handleResourceError(httpError) {
        var error = {
            status: httpError.status,
            message: "",
            errors: []
        };

        // Add child errors
        if (httpError.data && !_.isEmpty(httpError.data.errors)) {
            error.errors = _.transform(httpError.data.errors, function(result, n, key) {
                result[key] = {message: n.errorMessage};
            });
        }

        // Add correct error message
        if (httpError.data) {
            //Error from original RMS (ERP)
            if(!_.isEmpty(httpError.data.message))
                error.message = httpError.data.message;
            //Error from new RMS (RMS 2)
            else if(!_.isEmpty(httpError.data.error))
                error.message = httpError.data.error;
        } else {
            switch (httpError.status) {
                case 0:
                    error.message = $translate.instant('errors.noconnection');
                    break;
                case 401:
                    error.message = $translate.instant('errors.unauthorized');
                    break;
                case 404:
                    error.message = $translate.instant('errors.notfound');
                    break;
                default:
                    error.message = $translate.instant('errors.other');
                    break;
            }
        }

        return error;
    }

    function updateSavedTimestamp(resource) {
        savedTimestamps[resource] = Date.now();
    }

    function getSavedTimestamp(resource) {
        return savedTimestamps[resource] || 0;
    }
}

angular
    .module('resources', [
            'fileoperations.api',
            'filedataimport.api',
            'filedataimportv2.api',
            'navigation.api'
    ])
    .factory('ResourcesService', ResourcesService);
